












import { Component, Prop, Vue } from "vue-property-decorator";

const LISTA = [
  "Para quem não conhece o que veio fazer nesse mundo e, com isso, está sempre em dúvidas sobre o que estudar, com o que trabalhar ou até em qual cidade morar.",
  "Qualquer um que se sente frustrado, não consegue se realizar profissionalmente, não obtém resultados financeiros com o que faz ou percebe que sua vida não tem sentido.",
  "Para quem está infeliz com a atual situação que vive, especialmente, na relação com dinheiro, com trabalho e com a família.",
  "Pessoas que desejam viver em plenitude, mas está com dificuldades de superar medo, ansiedade e insegurança em relação aos acontecimentos no mundo.",
  "Homens e mulheres que desejam transformar sua vida de forma prática e definitiva e estão buscando alternativas para viver melhor, especialmente com o autoconhecimento.",
  "Pessoas que não se sentem valorizadas, compreendidas e amadas por outras pessoas que estão à sua volta."
];

@Component
export default class extends Vue {
  // @Prop() private msg!: string;
  itens: Array<Item> = [];

  // Lifecycle hook
  mounted() {
    let counter = 0;
    this.itens = LISTA.map(function(item) {
      counter++;
      return new Item(counter, item);
    });
  }
}

class Item {
  numero: number;
  nome: string;
  constructor(numero: number, nome: string) {
    this.numero = numero;
    this.nome = nome;
  }
}
